export default __webpack_public_path__ + "static/media/hero-about-us-image.0fca1bcd.png";